import { HStack } from '@bpba/ui-components';
import { SelectComponent } from '../shared/form/SelectComponent';
import { PROVINCIAS_OPCIONES } from '../../constants/data';
import { TextArea } from '../shared/form/TextArea';
import { FC } from 'react';
import { Domicilio } from '../../model/Domicilio';
import { InputText } from '../shared/form/InputText';
import { InputNumber } from '../shared/form/InputNumber';
import { InputContainerProps } from './InputSelectContainer';
import { InputZipcode } from '../shared/form/InputZipcode';
import {
  COMMENTS_MAX_LENGTH,
  DISTRICT_MAX_LENGTH,
  DOOR_MAX_LENGTH,
  FLAT_MAX_LENGTH,
  STREETNAME_MAX_LENGTH,
  STREETNUMBER_MAX,
  STREETNUMBER_MIN,
} from '../../constants/form';

type Props = InputContainerProps<Domicilio>;

export const FormularioDireccionNueva: FC<Props> = ({ register, errors }) => {
  return (
    <form>
      {/*Primera fila*/}
      <HStack>
        <SelectComponent
          placeholder="Provincia"
          options={PROVINCIAS_OPCIONES}
          name="provinceId"
          formRegister={register}
          errorCollection={errors}
          required={true}
          isNumber={true}
        />
        <InputText
          placeholder="Localidad"
          name="districtName"
          formRegister={register}
          errorCollection={errors}
          required={true}
          maxLength={DISTRICT_MAX_LENGTH}
        />
        <InputText
          placeholder="Calle"
          name="streetName"
          mr="0"
          formRegister={register}
          errorCollection={errors}
          required={true}
          maxLength={STREETNAME_MAX_LENGTH}
        />
      </HStack>
      {/*Segunda fila*/}
      <HStack display="flex">
        <InputNumber
          placeholder="Número"
          name="streetNumber"
          maxWidth={[65, null, 80, 90]}
          formRegister={register}
          errorCollection={errors}
          min={STREETNUMBER_MIN}
          max={STREETNUMBER_MAX}
          required={true}
        />
        <InputText
          placeholder="Piso"
          name="flat"
          maxWidth={[46, 45, 50, 60]}
          formRegister={register}
          errorCollection={errors}
          maxLength={FLAT_MAX_LENGTH}
        />
        <InputText
          placeholders={['Depto.', 'Departamento']}
          name="door"
          formRegister={register}
          errorCollection={errors}
          maxLength={DOOR_MAX_LENGTH}
        />
        <InputZipcode
          placeholders={['C.P.', 'Código postal']}
          name="zipCode"
          mr="0"
          formRegister={register}
          errorCollection={errors}
          required={true}
        />
      </HStack>
      {/*Tercera fila */}
      <TextArea
        placeholder="Comentarios"
        name="comments"
        mr="0"
        rows={3}
        formRegister={register}
        errorCollection={errors}
        maxLength={COMMENTS_MAX_LENGTH}
        aria-label="Comentarios"
      />
    </form>
  );
};
